/* eslint-disable @typescript-eslint/no-explicit-any -- TODO(lint-cleanup): remove disables and fix violations in a follow-up PR */
// /src/config/routes.ts
export const BASE_PATHS = {
  LANDOWNER: "/landowner",
  HUNTER: "/main",
  HOST: "/host",
};

// Helper to convert object to query string
const toQueryString = (params?: Record<string, any>) => {
  if (!params) return "";
  const query = new URLSearchParams(params).toString();
  return query ? `?${query}` : "";
};

export const ROUTES = {
  home: (base: string, query?: Record<string, any>) => `${base}/home${toQueryString(query)}`,
  booking: (base: string, query?: Record<string, any>) => `${base}/booking${toQueryString(query)}`,
  explore: (base: string, query?: Record<string, any>) => `${base}/explore${toQueryString(query)}`,
  notifications: (base: string, query?: Record<string, any>) =>
    `${base}/notifications${toQueryString(query)}`,
  message: (base: string, query?: Record<string, any>) => `${base}/message${toQueryString(query)}`,
  // T-296 — static thread route; threadId travels as ?thread= (not a path
  // segment) so the route can be statically exported under CAP_BUILD while
  // still resolving real UUIDs on the web/Node build.
  messageThread: (base: string, query?: Record<string, any>) =>
    `${base}/message/thread${toQueryString(query)}`,
  profile: (base: string, query?: Record<string, any>) => `${base}/profile${toQueryString(query)}`,
  hunt_status: (base: string, query?: Record<string, any>) =>
    `/hunt${base}/status${toQueryString(query)}`,
  ice_status: (base: string, query?: Record<string, any>) =>
    `/ice${base}/status${toQueryString(query)}`,
  // Landowner CRUD routes (T-026 / WS-2b)
  properties: (base: string, query?: Record<string, any>) =>
    `${base}/properties${toQueryString(query)}`,
  propertiesNew: (base: string, query?: Record<string, any>) =>
    `${base}/properties/new${toQueryString(query)}`,
  propertiesEdit: (base: string, id: string, query?: Record<string, any>) =>
    `${base}/properties/edit${toQueryString({ id, ...(query ?? {}) })}`,
  iceShacks: (base: string, query?: Record<string, any>) =>
    `${base}/ice-shacks${toQueryString(query)}`,
  iceShacksNew: (base: string, query?: Record<string, any>) =>
    `${base}/ice-shacks/new${toQueryString(query)}`,
  iceShacksEdit: (base: string, id: string, query?: Record<string, any>) =>
    `${base}/ice-shacks/edit${toQueryString({ id, ...(query ?? {}) })}`,
  // T-365 — flat, role-agnostic email-preferences opt-out page (every
  // transactional email footer links here). This entry is a convenience only:
  // the route resolves via app/settings/page.tsx alone, not this registry.
  settings: "/settings" as const,
  // Payout onboarding routes (T-038 / Stripe Connect)
  payoutSetup: "/landowner/payout-setup" as const,
  payoutReturn: "/landowner/payout-account/return" as const,
  payoutRefresh: "/landowner/payout-account/refresh" as const,
};

// External legal-document pages (T-223 Terms, T-260 Privacy & Booking Policy).
// The client (Gio) owns and publishes all three at accesshunter.com so the
// wording lives on the marketing site he controls; every in-app consent surface
// links here in a new tab/window rather than an internal /legal/* page.
// Defined once so the URLs can't drift across the ~ten surfaces that use them.
//
// CLIENT DEPENDENCY (T-260): these three pages must be live before launch —
// users affirm they have read them at signup. If any 404s, the link is dead.
export const TERMS_URL = "https://accesshunter.com/terms-and-conditions" as const;
export const PRIVACY_URL = "https://accesshunter.com/privacy-policy" as const;
export const BOOKING_POLICY_URL = "https://accesshunter.com/booking-policy" as const;
